// Flow types automatically removed

import { hydrateRoot } from 'react-dom/client';
import { QueryRenderer } from 'react-relay/legacy';
import SV from 'server-vars';
import { IntlProvider } from 'dibs-react-intl';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { getEnvironment } from '../relayModernEnvironment';
import { interiorsLandingRootQuery } from '../interiorsLanding/interiorsLandingRootQuery';
import { noticeError } from '../shared/helpers/newrelic';
import { InteriorsLandingWrapper } from '../interiorsLanding/InteriorsLandingWrapper';
const locale = SV.get('locale');
initializeDBL().then(() => {
    const variables = SV.get('relayVariables');
    const environment = getEnvironment(true);
    const containerElement = document.getElementById('js-root');

    if (containerElement === null) {
        // eslint-disable-next-line no-console
        console.error('Could not mount React due to missing #interiorsLandingContent element');
        return;
    }

    hydrateRoot(
        containerElement,
        <IntlProvider locale={locale} disableTranslations>
            <QueryRenderer
                environment={environment}
                fetchPolicy="store-and-network"
                query={interiorsLandingRootQuery}
                variables={variables}
                render={({ error, props }) => {
                    if (error) {
                        noticeError(error, 'error on loading interiors');
                        return null;
                    }

                    return <InteriorsLandingWrapper {...props} />;
                }}
            />
        </IntlProvider>
    );
});
